import { StyleSheet } from 'aphrodite/no-important';
import { children, media, palette, OIPResponsiveBackground } from 'util/style-helpers';

export const style: any = () => {
  return StyleSheet.create({
    mainContainer: {
      flexGrow: 1,
      background: 'white',
    },

    header: {
      padding: '20px 15px',
      fontSize: '27px',
      fontWeight: 'bold',
      color: '#FFF',

      [media.mobile]: {
        padding: '20px 40px',
      },

      [media.desktop]: {
        display: 'none',
      },
    },

    h1: {
      fontSize: '20px',
      textAlign: 'center',

      [children('.amp')]: {
        fontWeight: 400,
      },
    },

    h2: {
      fontSize: '20px',
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: 10,

      [media.tablet]: {
        fontSize: '30px',
      },
    },

    onlineBanner: {
      background: palette.red,
      display: 'flex',
      justifyContent: 'center',
      padding: '10px 0',
      fontSize: '27px',
      fontWeight: 'bold',

      [media.desktop]: {
        display: 'none',
      },
    },

    welcomeSectionContainer: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      minHeight: '100vh',
      margin: '0 auto',
      color: palette.white,
      ...OIPResponsiveBackground({ opacity: 'light', fixed: false }),
      zIndex: 2,

      [media.desktop]: {
        margin: '0 auto',
      },
    },

    welcomeSection: {
      backgroundColor: 'transparent',
      marginBottom: 30,
      padding: '0px 20px',
      lineHeight: 1.375,
      color: palette.white,
      flexGrow: 1,

      [media.tablet]: {
        maxWidth: '622px',
      },
      [media.desktop]: {
        fontSize: 14,
        padding: '0px 39px',
        maxWidth: '662px',
      },

      [media.landscapeTablet]: {
        top: 20,
      },

      [media.xl]: {
        width: 675,
      },

      [children('p')]: {
        fontSize: '16px',
        lineHeight: '22px',
      },
    },

    scrollDown: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: 15,
      [media.tablet]: {
        marginBottom: 30,
      },
      [children('img')]: {
        width: '32px',
        height: 'auto',
      },
      [children('button')]: {
        border: 'none',
        background: 'transparent',

        ':focus': {
          outline: 'none',
        },
      },
      [children('p')]: {
        margin: '5px 0 0',
      },
    },

    agendaSection: {
      padding: '30px 16px 10px 16px',
      margin: '0px auto',
      maxWidth: 980,
      [media.tablet]: {
        padding: '60px 24px 50px',
      },

      [media.desktop]: {
        padding: '130px 20px 200px',
      },
    },

    agendaHeadline: {
      color: palette.red,
      marginTop: 30,
      marginBottom: 30,
      fontSize: 25,

      [media.tablet]: {
        fontSize: 36,
        marginTop: 40,
        marginBottom: 65,
      },

      [media.desktop]: {
        marginTop: 70,
        marginBottom: 70,
        fontSize: 40,
      },
    },

    agendaEventContainer: {
      // margin: '0 -15px',
      // padding: '0 15px',
    },

    agendaEvent: {
      background: palette.red,
      color: '#FFF',
      fontSize: '30px',
      lineHeight: '24px',
      padding: '16px 0',
      textAlign: 'center',

      [media.desktop]: {
        fontSize: '22px',
        lineHeight: '29px',
        textAlign: 'left',
        padding: 0,
      },

      [media.xl]: {
        lineHeight: 1.375,
      },
    },

    agendaEventTitle: {
      fontSize: 20,
      fontWeight: 'bold',

      [media.desktop]: {
        fontSize: 22,
      },

      [media.xl]: {
        fontSize: 28,
      },
    },

    agendaEventSubTitle: {
      fontSize: 20,
      fontWeight: 400,

      [media.desktop]: {
        fontSize: 22,
      },

      [media.xl]: {
        fontSize: 28,
      },
    },

    loginButton: {
      background: 'linear-gradient(180deg, rgba(230,0,18,1) 0%, rgba(152,0,12,1) 100%)',
      color: '#FFF',
      display: 'block',
      border: 'none',
      padding: '10px 27px',
      borderRadius: '7px',
      fontSize: '20px',
      fontWeight: 'bold',
      lineHeight: '24px',
      marginBottom: 24,
      boxShadow: '0px 3px 6px rgb(0, 0, 0, 0.4)',

      [media.tablet]: {
        padding: '12px 35px',
        fontSize: '24px',
        lineHeight: '29px',
        marginBottom: 45,
        marginTop: 20,
      },

      [media.desktop]: {
        background: palette.red,
      },
    },

    loginInput: {
      color: palette.white,
      width: '100%',
      border: '1px solid #DEDEDF',
      padding: '10px 11px',
      borderRadius: '4px',
      margin: '0 -15px 0px -15px',
      textTransform: 'uppercase',
      fontWeight: 'bold',
      background: 'transparent',

      '::placeholder': {
        letterSpacing: 'initial',
        textTransform: 'initial',
        fontSize: 'initial',
        fontWeight: 'initial',
        textAlign: 'initial',
      },

      [media.tablet]: {
        padding: '10px 18px',
      },

      [media.desktop]: {
        fontSize: 14,
      },
    },

    inputLabel: {
      fontSize: '16px',
      lineHeight: '22px',
      alignSelf: 'flex-start',
      marginBottom: 20,

      [media.tablet]: {
        marginBottom: 45,
      },
    },

    loginForm: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',

      [children('a')]: {
        color: palette.red,
        padding: '11px 18px',
        borderRadius: 10,
        border: `1px solid ${palette.red}`,
        [media.tablet]: {
          padding: '14px 28px',
        },
      },
    },

    keynote: {
      background: '#E8E7E7',
      padding: '16px 20px',

      [media.mobile]: {
        padding: '22px 32px',
      },

      [media.tablet]: {
        padding: '32px 31px',
      },

      [media.desktop]: {
        padding: '0',
      },

      [children('p')]: {
        marginBottom: 0,
      },
    },

    keynoteTimeContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      marginBottom: 18,

      [media.tablet]: {
        justifyContent: 'start',
      },

      [media.desktop]: {
        padding: 0,
        justifyContent: 'center',
        marginBottom: 0,
        flexDirection: 'column',
        alignItems: 'center',
      },
    },

    keynoteTime: {
      fontWeight: 'bold',
      fontSize: 18,
      alignSelf: 'center',

      [media.mobile]: {
        fontSize: 20,
      },

      [media.tablet]: {
        fontSize: 28,
        marginRight: 23,
      },

      [media.desktop]: {
        fontSize: 20,
        margin: '0 0 7px 0',
      },

      [media.xl]: {
        fontSize: 28,
      },
    },

    streamingLiveBadge: {
      background: palette.red,
      color: '#FFF',
      border: 'none',
      padding: '8px 13px',
      fontSize: 14,
      fontWeight: 400,

      [media.mobile]: {
        fontSize: 15,
      },

      [media.tablet]: {
        fontSize: 16,
      },

      [media.desktop]: {
        marginBottom: 0,
        fontSize: 12,
        padding: '6px 11px',
        display: 'block',
        width: 'max-content',
      },

      [media.xl]: {
        fontSize: '16px',
        padding: '10px 20px',
      },
    },

    keynoteDescription: {
      fontSize: 15,

      [media.tablet]: {
        fontSize: 22,
      },

      [media.desktop]: {
        fontSize: 16,
        padding: 0,
      },
    },

    onDemand: {
      padding: '16px 20px',
      background: '#f5f5f5',
      marginBottom: 11,

      [children('ul:last-child')]: {
        marginBottom: 0,
      },

      [media.mobile]: {
        padding: '22px 32px',
      },

      [children('h3')]: {
        fontSize: 20,
        marginBottom: 25,
      },

      [children('h4')]: {
        fontSize: 17,
        marginBottom: '12px',
      },

      [children('ul')]: {
        marginLeft: 0,
        paddingLeft: 0,
        marginBottom: 31,
        listItem: 'disc',
        listStylePosition: 'outside',
      },

      [children('li')]: {
        fontSize: 15,
        marginBottom: 7,
        lineHeight: 1.45,
        marginLeft: 15,
      },

      [media.tablet]: {
        marginBottom: 20,
        padding: '32px 31px',

        [children('h3')]: {
          fontSize: 28,
        },

        [children('h4')]: {
          fontSize: 22,
        },

        [children('li')]: {
          fontSize: 22,
        },
      },

      [media.desktop]: {
        alignSelf: 'flex-start',
        padding: 0,

        [children('h3')]: {
          fontSize: 20,
        },

        [children('h4')]: {
          fontSize: 16,
        },

        [children('ul')]: {
          marginBottom: 25,
        },

        [children('li')]: {
          fontSize: 16,
          marginBottom: 7,
          lineHeight: 1.45,
        },
      },

      [media.xl]: {
        [children('h4')]: {
          fontSize: 22,
        },

        [children('li')]: {
          fontSize: 22,
        },
      },
    },

    featuredSpeakersSection: {
      background: '#F5F5F5',
      backgroundImage: `linear-gradient(${palette.black}, ${palette.darkGrey})`,
      color: palette.white,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },

    speakersGrid: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-evenly',

      [media.mobile]: {
        maxWidth: 320,
      },

      [media.tablet]: {
        justifyContent: 'space-between',
        maxWidth: 720,
      },

      [media.desktop]: {
        maxWidth: 960,
      },
    },

    errorMessage: {
      color: palette.red,
      fontSize: '16px',
      alignSelf: 'flex-start',
      marginTop: '10px',
    },
  });
};

export const speakerStyle: any = (columns: number) => {
  return StyleSheet.create({
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      width: 'calc(124px * 2 + 30px)',
      [media.tablet]: {
        width: columns === 3 ? 'calc(222px * 3 + 30px * 2)' : 'calc(222px * 2 + 80px)',
      },
      [media.desktop]: {
        width: columns === 3 ? 'calc(290px * 3 + 30px * 2)' : 'calc(290px * 2 + 80px)',
      },
    },
  });
};
